'use strict'

IframeLogin = window.IframeLogin || {}

IframeLogin.openModal = (path = window.location.href) ->
  @destination = path
  GIG.Modal.open
    el: @$modal

  frames[@iframeName]?.IframeLogin?.iframeView?.resetHeight?()
